import { useEffect, useState } from "react";
import {
  Autocomplete,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  TextFielDecimalNumbers
} from "../../../components";
import { filtrosUrl, value } from "../../../helpers";
import { GrupoPessoasService } from "../../../services";
import { cacheApi, responseErros, unformatPrice } from "../../../utils";
import { constantes } from "../../pessoas/addPessoa/resources";

export default function TabProfissional({
  profissionalSelecionado,
  linhaSelecionada,
  cacheDto,
  setCacheDto,
  inputErros
}) {
  const [listaGrupoPessoa, setListaGrupoPessoa] = useState([]);
  const [profissional, setProfissional] = useState(profissionalSelecionado);

  const grupoPessoasService = new GrupoPessoasService();

  useEffect(() => {
    buscaGruposPessoas();
  }, []);

  const buscaGruposPessoas = async () => {
    const filtros = {
      ativado: true,
      tipoPessoa: 6,
      restritiva: true,
    };
    const label = filtrosUrl.getUrl(filtros, grupoPessoasService.urlBase);
    const cacheBody = {
      apiFunction: grupoPessoasService.getAllFiltroAvancado(filtros),
      dto: { cacheDto, setCacheDto },
    };
    const res = await cacheApi(label, cacheBody);
    if (!res.isAxiosError) {
      setListaGrupoPessoa(res.data.rows);
    } else {
      responseErros(res);
    }
  };

  const handleChangeAutocomplete = (name, value) => {
    profissionalSelecionado.setAtributo(name, value?.id);
    setProfissional({ ...profissionalSelecionado });
  };

  const handleChangeInput = (event) => {
    const { name, value } = event.target;
    profissionalSelecionado.setAtributo(name, value);
    setProfissional({ ...profissionalSelecionado });
  };

  const handleChangeCurrencyInput = (event) => {
    const { name, value } = event.target;
    const valor = unformatPrice(value);
    profissionalSelecionado.setAtributo(name, Number(valor));
    setProfissional({ ...profissionalSelecionado });
  };

  return (
    <Grid container spacing={2} className="mt-1">
      <Grid item xs={4}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            id="grupoPessoaId"
            name="grupoPessoaId"
            options={listaGrupoPessoa}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) => (option.nome ? option.nome : "")}
            filterSelectedOptions
            onChange={(_, value) => 
              handleChangeAutocomplete("grupoPessoaId", value)
            }
            value={value.autoComplete(
              listaGrupoPessoa,
              profissional?.grupoPessoaId,
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Grupos de Pessoas"
              />
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xs={4}>
        <Select
          label="Profissão"
          id="profissao"
          name="profissao"
          margin="normal"
          error={inputErros?.get(`[${linhaSelecionada}].profissional.profissao`)}
          value={profissional?.profissao || ""}
          onChange={handleChangeInput}
        >
          {constantes.profissoesList.map((profissao) => (
            <MenuItem key={profissao.value} value={profissao.label}>
              {profissao.label}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item xs={4}>
        <TextFielDecimalNumbers
          label="Comissão"
          name="comissao"
          variant="outlined"
          fullWidth
          onBlur={handleChangeCurrencyInput}
          value={profissional?.comissao ?? ""}
          error={inputErros.get("comissao")}
        />
      </Grid>
    </Grid>
  );
}
